import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'tinper-bee';
import { observer } from 'mobx-react';
import _map from 'lodash/map';
import _truncate from 'lodash/truncate';
import {history,stores} from 'mutants-microfx';
import { getFixedNumber } from './utils'


@observer
export default class extends Component {
    timer;
	constructor(props) {
        super(props);
        this.state={times:20}
	}

	static contextTypes = {
		stores: PropTypes.object
	};

	componentWillMount() {
		let { selfSettlementStore } = this.context.stores;
		this.store = selfSettlementStore;
	}

	componentDidMount() {
        this.timer=setInterval(()=>{
            let time=this.state.times-1;
            this.setState({times:time});
            if(time==0){
                this.btnClick();
            }
        }, 1000);
    }

    componentWillUnmount(){
        clearInterval(this.timer);
    }

    btnClick(){
        stores.voucherStore.clearData();
        history.push('/RE/RE01');
        // history.push('/selfFailure');
      }

	render() {
        let {amount,quantity,discount,member}=this.store;
		return (
        <div className="selfSettle">
            <div className="content">
                <div className="success">支付成功</div>
                <div className="welcome">欢迎下次光临</div>
                <div className="paycontainer"><div className="payok"></div></div>
                {member && member.id &&<div className="member">
                    <span className="title">{member.type}</span>
                    <span className="value">{member.cardNo}</span>
                </div>}
                {member && member.id &&<div className="member">
                    <span className="title">余额</span>
                    <span className="value value2">{getFixedNumber(member.balance-amount)}</span>
                </div>}
                <div className="seperator">
                    <div className="left"></div>
                    <div className="middle"></div>
                    <div className="right"></div>
                </div>
                <div className="total">
                    <span className="title">商品金额</span>
                    <span className="value">{getFixedNumber(Math.Add(amount,discount))}</span>
                </div>
                <div className="discount">
                    <span className="title">优惠金额</span>
                    <span className="value">{getFixedNumber(discount)}</span>
                </div>
                <div className="discount">
                    <span className="title">{`共${quantity}件`}</span>
                    <span className="value">{getFixedNumber(amount)}</span>
                </div>
                
                
                <div className="button successbtn">
                    <Button onClick={this.btnClick}>{`返回（${this.state.times}s）`}</Button>
                </div>
            </div>
			
		</div>);
	}
}
